export const schema = {
  properties: {
    copy_configuration_from: {
      type: 'string',
      oneOf: [{ const: 'select', title: 'Select' }],
      optional: true,
    },
    scan_root: {
      type: 'string',
    },
    username: {
      type: 'string',
    },
    password: {
      type: 'string',
    },
    privateKey: {
      type: 'string',
    },
    certificate: {
      type: 'string',
    },
    tls_algo: {
      type: 'string',
      enum: ['Basic128Rsa15', 'Basic256', 'Basic256Sha256', 'Aes128Sha256RsaOaep'],
    },
    messages: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          id: {
            type: 'string',
          },
          type: {
            type: 'string',
            oneOf: [
              { const: 'periodic', title: 'Poll periodically' },
              { const: 'trigger', title: 'Subscribe to change' },
            ],
          },
          trigger: {
            type: 'string',
          },
          comparison: {
            type: 'string',
            enum: ['changes', '==', '<=', '>=', '<', '>', '!='],
          },
          refresh_interval: {
            type: 'number',
          },
          value: {
            type: 'string',
          },
          props: {
            type: 'array',
            items: {
              type: 'object',
              properties: {
                id: {
                  type: 'string',
                },
                key: {
                  type: 'string',
                },
                uom: {
                  type: 'string',
                },
              },
            },
          },
        },
      },
    },
  },
};
